import React from "react";

import { Switch, Route, withRouter } from "react-router-dom";

import "../../styles/css/App.css";

import PlaceCategories from "./map/places/categories/categories"
import Eboards from "./eboards/vehicles/live"
import Errors from "./errors/errors"

function Router( { history, base } ) {
  
  return (
    <Switch>
      <Route path={`${base}/map/places/categories`}>
        <PlaceCategories />
      </Route>
      <Route path={`${base}/eboards/vehicles/live`}>
        <Eboards />
      </Route>
      <Route path={`${base}/errors`}>
        <Errors />
      </Route>
    </Switch>
  );

}

export default withRouter(Router);
